import React from 'react';
import './FilterSection.css';

/**
 * Generic FilterSection component that renders filter buttons
 * 
 * @param {Object} props Component props
 * @param {Object} props.activeFilters Current active filters
 * @param {Function} props.onFilterChange Function to call when a filter changes
 * @param {Array} props.filterGroups Array of filter groups to display
 */
const FilterSection = ({ activeFilters, onFilterChange, filterGroups }) => {
  return (
    <>
      {filterGroups && filterGroups.map((group, groupIndex) => (
        <div className="filter-section" key={groupIndex}>
          <h3>{group.title}</h3>
          {group.options.map((option, optionIndex) => (
            <button 
              key={`${group.id}-${optionIndex}`}
              className={`filter-button ${option.className || ''} ${activeFilters[group.id] === option.value ? 'active' : ''}`}
              onClick={() => onFilterChange(group.id, option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      ))}
    </>
  );
};

export default FilterSection; 